import type { ScriptFunctionReturn } from '../../types';

export function getPeacockScript(
  productId: string,
  accessToken: string
): ScriptFunctionReturn {
  const sdkLoader = `
   !function(window, document) {
      if (window.pubSuite) {
            return;
      }
      var id = 'peacock-pixel'
      if (!document.getElementById(id)) {
        const pubSuiteScript = document.createElement("script");
        pubSuiteScript.type = "text/javascript";
        pubSuiteScript.src = "https://storage.googleapis.com/kochava-web-assets/ps/v1.3.0/pubsuite.js";
        pubSuiteScript.async = true;
        pubSuiteScript.id = id;

        pubSuiteScript.onload = () => {
            const product_id = '${productId}';
            const access_token = '${accessToken}';
            window.pubSuite.startWithProductId(product_id, access_token);
        };
        document.head.appendChild(pubSuiteScript);
      }
    }(window, document);
  `;

  return { sdkLoader };
}
